"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var CreateTypeButton = function (_a) {
    var InputProps = _a.InputProps, Icon = _a.Icon, isEnabled = _a.isEnabled, onChange = _a.onChange, children = _a.children;
    var classes = InputProps.classes;
    var theme = (0, core_1.useTheme)();
    return (react_1.default.createElement(core_1.Button, { variant: isEnabled ? 'text' : 'contained', className: "".concat(classes.linkTypeButton, " ").concat(isEnabled ? '' : classes.linkTypeButtonEnabled), onClick: onChange },
        react_1.default.createElement(Icon, { color: isEnabled
                ? theme.palette.primary.dark
                : theme.palette.background.default }),
        react_1.default.createElement(core_1.Typography, { variant: "body2", className: classes.linkTypeButtonText }, children)));
};
exports.default = CreateTypeButton;
